import EventEmitter from 'eventemitter3'

const walletEvents = new EventEmitter()

export default walletEvents
